import styles from '../../index.module.css';
import Footer from '../Footer';
import Loader from '../../../../components/Loader';
import NavBar, { View } from '../../../../components/NavBar';
import { useTheme } from '../../../../hooks/common/useTheme';

const PatientTermsOfUse: React.FC = () => {
  const { isThemeLoading } = useTheme();
  if (isThemeLoading) return <Loader />;

  return (
    <>
      <NavBar view={View.TermsOfService} onBackButtonClicked={() => {}} />
      <div className={styles.SchedulingContainer}>
        <div className={styles.PatientTermsOfUseOuterContainer}>
          <div className={styles.PatientTermsOfUseInnerContainer}>
            <div className={styles.PatientTermsOfUseContent}>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>NOTABLE HEALTH</b>
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>PATIENT END USER TERMS OF USE</b>
                </span>
              </p>
              <p className={styles.p1}>
                <span className={styles.s1}></span>
                <br />
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>Last updated: </span>
                <br />
                <span className={styles.s2}>June 7, 2022</span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>
                    IMPORTANT: PLEASE READ THESE TERMS CAREFULLY BEFORE USING
                    THE NOTABLE PLATFORM.
                  </b>
                </span>
              </p>
              <br />
              <p className={styles.p5}>
                <span className={styles.s1}>
                  These Terms of Use (the "<b>Terms</b>") are a legally binding
                  contract between the user ("<b>you</b>") and Zealth, Inc.
                  d/b/a Notable Health, ("<b>Notable</b>," "<b>we</b>," or "
                  <b>us</b>"). Notable provides the Services (as defined below)
                  to you subject to these Terms, which may be updated by Notable
                  from time to time without prior notice to you. These Terms
                  govern your use of the Services.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Supplemental terms of use or documents that may be posted on
                  or provided through the Notable Platform from time to time are
                  hereby expressly incorporated herein by reference. We reserve
                  the right, in our sole discretion, to make changes,
                  modifications, or updates to these Terms at any time and for
                  any reason. We will alert you about any changes by updating
                  the “Last updated” date of these Terms and you waive any right
                  to receive specific notice of each such change. It is your
                  responsibility to periodically review these Terms to stay
                  informed of updates. You will be subject to and will be deemed
                  to have been made aware of and to have accepted, the changes
                  in any revised Terms by your continued use of the Site and/or
                  Notable Platform after the date such revised Terms are posted.
                  Unless explicitly stated otherwise, any new features that
                  augment or enhance the current Notable Platform, including the
                  release of new Notable properties, shall be subject to these
                  Terms.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  BY ACCESSING AND USING THE SERVICES IN ANY WAY, OR BY CLICKING
                  TO ACCEPT OR AGREE TO THESE TERMS WHEN THIS OPTION IS MADE
                  AVAILABLE TO YOU, YOU AGREE TO BE BOUND BY THESE TERMS,
                  INCLUDING THE WARRANTY DISCLAIMERS, LIMITATIONS OF LIABILITY,
                  AND TERMINATION PROVISIONS BELOW. IF YOU DO NOT AGREE TO THE
                  TERMS, DO NOT USE THE SERVICES OR THE NOTABLE PLATFORM.
                </span>
              </p>
              <p className={styles.p6}>
                <span className={styles.s1}>
                  <b>1. DESCRIPTION OF THE SERVICES</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Notable provides a patient-facing web application (the “
                  <b>Notable Platform</b>”), which allows patients to complete
                  various tasks as part of the patient intake process, which may
                  include collection of demographic, social and clinical data,
                  consent forms, insurance, payments and other information (the
                  "<b>Services</b>"). The specific features of the Services that
                  are available may change from time to time, and Notable may
                  choose to discontinue some or all of the Services, at its
                  discretion.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  You understand and agree that the Services may include certain
                  communications from Notable, such as service announcements and
                  administrative messages. You consent to receive such
                  communications from us electronically. Unless explicitly
                  stated otherwise, any new features that augment or enhance the
                  current Services shall be subject to these Terms.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  The Services include or may include information, data, text,
                  messages, software, audio, video, photographs, graphics,
                  images, tags, and/or other materials ("<b>Content</b>"). You
                  acknowledge and agree that the Content available through the
                  Services may be obtained or derived from third-party sources
                  (collectively, "<b>Content Providers</b>"), such as
                  individuals or entities that have created and contributed such
                  Content to the Notable Platform. Content may also include
                  materials and communications that the entity providing
                  healthcare services to you (“
                  <b>Healthcare Organization</b>”) decides to make available to
                  you via the Notable Platform. Your use of any Content,
                  including, without limitation any medical information, is at
                  your own risk, as described in more detail below.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>2. CONDITIONS ON ACCESS TO THE SERVICES</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  We reserve the right to withdraw or amend the Notable
                  Platform, and any service or material we provide on the
                  Notable Platform, in our sole discretion without notice. From
                  time to time, we may restrict access to some parts of the
                  Notable Platform, or the entire Notable Platform, to users,
                  including registered users.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  You acknowledge and agree that your use of the Services is
                  dependent upon access to telecommunications and Internet
                  services. You further understand that your use of the Services
                  may involve or require the transmission of significant amounts
                  of data. You understand and agree that you are solely
                  responsible for acquiring and maintaining all
                  telecommunications and Internet services and other hardware
                  and software required to access and use the Services,
                  including, without limitation, any and all costs, fees,
                  expenses and taxes of any kind related to the foregoing or
                  that may otherwise arise from your use of the Services.
                  Notable shall not be responsible for any loss or corruption of
                  data, lost communications, loss of functionality or any other
                  loss or damage of any kind arising from any such
                  telecommunications and Internet services. WITHOUT LIMITING THE
                  FOREGOING, YOU ACKNOWLEDGE THAT YOUR USE OF THE SERVICES MAY
                  REQUIRE AN APPROPRIATE MOBILE DEVICE AND DATA PLAN, AND THE
                  PURCHASE AND MAINTENANCE OF SUCH DEVICE AND PLAN AND
                  ASSOCIATED CHARGES ARE YOUR RESPONSIBILITY (AND NOT
                  NOTABLE'S).
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Use of the Services is void where prohibited. By using and/or
                  viewing the Notable Platform, you represent and warrant that
                  you have the right, authority, and capacity to agree to and
                  abide by these Terms and that you are not prohibited by law
                  from using the Services.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>3. NOT MEDICAL ADVICE; DISCLAIMERS</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Notable does not provide medical advice and does not make
                  diagnostic, treatment, or other clinical decisions or
                  judgments. The Services and Content are not a substitute for
                  the competent analysis and professional judgment of health
                  care professionals. The medical information that is provided
                  to you through the Services is dependent upon the Content that
                  you access and the information that you select and enter, as
                  well the specifics of your situation. NEITHER NOTABLE NOR ANY
                  CONTENT PROVIDER WARRANTS OR GUARANTEES THAT THE MEDICAL
                  INFORMATION OBTAINED THROUGH THE SERVICES WILL BE ACCURATE,
                  RELEVANT, OR UP TO DATE. USE OF THE NOTABLE PLATFORM IS NOT
                  FOR EMERGENCY SITUATIONS. IN THE EVENT OF AN EMERGENCY, PLEASE
                  DIAL 911. IF YOU NEED URGENT CARE, PLEASE CONTACT YOUR
                  PROVIDER BY TELEPHONE OR IN PERSON OR VISIT AN URGENT CARE
                  CENTER.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  By accessing the Services, you assume full responsibility for
                  the use of any information obtained through the Services and
                  agree that neither Notable nor any of its licensors or Content
                  Providers is responsible or liable for any claim, loss, or
                  damage arising from the use of the information. Your reliance
                  upon the Content obtained or used by you through the Services
                  is solely at your own risk.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>4. NOTABLE'S PROPRIETARY RIGHTS</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  The Content is protected by applicable intellectual property
                  and other laws, including patent, trademark, and copyright
                  laws. All Content and all intellectual property in the Content
                  belongs to and is the property of Notable or its licensors.
                  Without limiting the preceding sentence, we own and retain all
                  intellectual property rights in the features, and
                  functionality (including but not limited to all information,
                  software, text, displays, images, video, and audio, and the
                  design, selection, and arrangement thereof) contained in the
                  individual pages, components of pages, and any collective
                  works contained within the Notable Platform. The Content may
                  not be copied, reproduced, modified, published, uploaded,
                  posted, transmitted, performed, or distributed in any way, and
                  you agree not to modify, rent, lease, loan, sell, distribute,
                  transmit, broadcast, or create derivative works based on the
                  Content or the Services, in whole or in part, by any means,
                  except as expressly authorized in writing by Notable or the
                  Content Provider, as applicable. Notable and the Notable logos
                  are trademarks and the property of Notable. The appearance,
                  layout, color scheme, and design of the Notable Platform are
                  protected trade dress. All other names and trademarks are the
                  property of their respective holders.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>5. LIMITED USE LICENSE</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Notable grants you a non-transferable and non-exclusive right
                  and license to access and use the Services solely for your
                  personal use as authorized by your Healthcare Organization,
                  and subject to the condition that you do not (and do not allow
                  any third party to) (a) copy, modify, create a derivative work
                  from the Services or the Content, and (b) reverse engineer,
                  reverse assemble or otherwise attempt to discover any source
                  code. You agree not to modify the Services in any manner or
                  form, nor to use modified versions of the Services or
                  software, including (without limitation) for the purpose of
                  obtaining unauthorized access to the Services. You agree not
                  to access the Services by any means other than through the
                  interface(s) provided by Notable for use in accessing the
                  Services. You agree that you shall not develop, sell, license,
                  or distribute applications that launch, are launched from, or
                  are otherwise integrated with the Services without the prior
                  express written consent of Notable. You agree that you will
                  not rent, lease, loan, resell for profit, distribute,
                  sublicense or use in a time-sharing arrangement the Services,
                  in whole or in part. Any unauthorized use of the Content or
                  any Services may violate patent, copyright, trademark, and
                  other laws. You agree to cooperate with Notable to prevent any
                  unauthorized copying of the Services or Content.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>6. TERMINATION</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Your use of the Services is subject to and expressly
                  conditioned on your compliance with these Terms. We may
                  terminate and/or suspend your access to any portion of the
                  Services upon notice to your Healthcare Organization in the
                  event that we reasonably determine that you have violated the
                  Terms.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Upon termination, you shall immediately destroy any Content in
                  your possession, if any, and cease use of the Services.
                  Sections 3, 4, 5, 6 and 8 through 21 shall survive termination
                  of these Terms for any reason.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>7. SECURITY</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  The Services are designed to require users to provide a unique
                  code to access and use the Services (your "<b>Credentials</b>
                  ").
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  You are solely responsible for (1) maintaining the strict
                  confidentiality of your Credentials, (2) not allowing another
                  person to use your Credentials to access the Services, (3) any
                  and all damages or losses that may be incurred or suffered as
                  a result of any activities that occur under your Credentials.
                  You agree to immediately notify Notable in writing of any
                  unauthorized use of your Credentials or any other breach of
                  security, and to ensure that you sign out from your account at
                  the end of each session. Notable is not and shall not be
                  liable for any harm arising from or relating to the theft of
                  your Credentials, your disclosure of your Credentials, or the
                  use of your Credentials by another person or entity.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Any attempt to obtain unauthorized access or to exceed
                  authorized access to the Services shall be considered a
                  trespass and computer fraud and abuse, punishable under state
                  and federal laws. Notable hereby notifies you that any or all
                  communications with the Services can and will be monitored,
                  captured, recorded, and transmitted to the authorities as
                  deemed necessary by Notable in its sole discretion and without
                  further notice.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>8. MESSAGING AND OPT OUT</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  1. By opting in as a user of our Services, you understand and
                  acknowledge that you will be receiving messages that your
                  Healthcare Organization(s) and/or healthcare provider(s) are
                  trying to send to you regarding your care.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  2. You can cancel the SMS service at any time. Just text
                  "STOP" to the short code. After you send the SMS message
                  "STOP" to us, we will send you an SMS message to confirm that
                  you have been unsubscribed. After this, you will no longer
                  receive SMS messages from us. If you want to join again, just
                  sign up as you did the first time and we will start sending
                  SMS messages to you again.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  3. If you are experiencing issues with the messaging program
                  you can reply with the keyword HELP for more assistance, or
                  you can get help directly at support@NotableHealth.com.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  4. Carriers are not liable for delayed or undelivered
                  messages.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  5. As always, message and data rates may apply for any
                  messages sent to you from us and to us from you. The frequency
                  with which you will receive messages may vary according to the
                  frequency with which you use Notable’s Services. If you have
                  any questions about your text plan or data plan, it is best to
                  contact your wireless provider.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  6. If you have any questions regarding privacy, please read
                  our privacy policy:
                  <a href="https://www.notablehealth.com/privacy-policy">
                    {' '}
                    https://www.notablehealth.com/privacy-policy
                  </a>
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>9. USER-SUBMITTED CONTENT; FEEDBACK</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  The Services may permit you to submit information and Content
                  (including data, images, sounds, text, and other things
                  embodied therein) or provide ideas, suggestions, and proposals
                  (collectively, "<b>Submissions</b>").
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Notable and its designees shall have the right (but not the
                  obligation) in their sole discretion to pre-screen, refuse, or
                  remove any Submissions or Content that is available via the
                  Services. Without limiting the foregoing, Notable and its
                  designees shall have the right to remove any Content that
                  violates these Terms or is otherwise objectionable, in
                  Notable's reasonable and sole discretion.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  By making a Submission to the Services, you hereby grant to
                  Notable the right to collect, store, use, reproduce,
                  distribute, modify, publish and prepare derivative works from
                  the Submissions for purposes of providing the Services
                  consistent with these Terms and applicable law.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  You acknowledge and agree that Notable may collect, analyze
                  and use anonymized or aggregated data regarding the usage and
                  performance of the Services, including data derived from
                  protected health information, and create aggregate data that
                  is: (a) not identifiable to any person and, to the extent
                  derived from protected health information, complies with 45
                  C.F.R. § 164.514(b), and (b) is not distributed or otherwise
                  conveyed in a context that identifies your identity (“
                  <b>De-identified Data</b>
                  ”). Unless otherwise required by applicable law, Notable may
                  retain and use the De-identified Data without restriction for
                  any purpose, including, but not limited to, operating,
                  analyzing, improving or marketing the Services and any related
                  products and services.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  In the event you decide to provide any feedback,
                  recommendations and/or suggestions with respect to the
                  Services (collectively, “<b>Feedback</b>”), you hereby assign
                  and agree to assign to Notable all of your title, right and
                  interest, including all associated intellectual property
                  rights, in and to the Feedback.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>10. USER CONDUCT</b>
                </span>
              </p>
              <p className={styles.p7}>
                <span className={styles.s1}>
                  You agree that you shall not in connection with your use of
                  the Services to:
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  i. upload, post, email, transmit or otherwise make available
                  any Submissions that is unlawful, harmful, threatening,
                  abusive, harassing, tortuous, defamatory, vulgar, obscene,
                  libelous, invasive of another's privacy, hateful, or racially,
                  ethnically or otherwise objectionable;
                </span>
              </p>
              <p className={styles.p7}>
                <span className={styles.s1}>ii. harm minors in any way;</span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  iii. impersonate any person or entity, or falsely state or
                  otherwise misrepresent your affiliation with a person or
                  entity;
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  iv. upload, post, email, transmit or otherwise make available
                  any Submissions that you do not have a right to make available
                  under any law or under contractual or fiduciary relationships;
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  v. upload, post, email, transmit or otherwise make available
                  any Submissions that infringes any patent, trademark, trade
                  secret, copyright or other proprietary rights ("<b>Rights</b>
                  ") of any party;
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  vi. upload, post, email, transmit or otherwise make available
                  any unsolicited or unauthorized advertising, promotional
                  materials, "junk mail," "spam," "chain letters," "pyramid
                  schemes," or any other form of solicitation, except in those
                  areas that may be designated for such purpose;
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  vii. upload, post, email, transmit or otherwise make available
                  any material that contains software viruses or any other
                  computer code, files or programs designed to interrupt,
                  destroy or limit the functionality of any computer software or
                  hardware or telecommunications equipment;
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  viii. interfere with or disrupt the Services or servers or
                  networks connected to the Services, or disobey any
                  requirements, procedures, policies or regulations of networks
                  connected to the Services, including using any device,
                  software or routine to bypass robot exclusion headers; and/or
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  ix. violate any applicable local, state, national or
                  international law or any regulations having the force of law.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  You acknowledge, consent and agree that Notable may access,
                  preserve and disclose your Registration Data, Submissions,
                  user profile, and other Content if required to do so by law or
                  in a good faith belief that such access, preservation, or
                  disclosure is reasonably necessary to: (i) comply with legal
                  process; (ii) enforce these Terms; (iii) respond to claims
                  that any Content violates the rights of third parties; (iv)
                  respond to your requests for customer service; or (v) protect
                  the rights, property or personal safety of Notable, its users,
                  and the public.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>11. DISCLAIMER OF WARRANTIES</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  EXCEPT AS EXPRESSLY PROVIDED HEREIN, NOTABLE DISCLAIMS ALL
                  WARRANTIES WITH RESPECT TO THE SERVICES, WHETHER EXPRESS OR
                  IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED WARRANTY OF
                  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, AND
                  NONINFRINGEMENT. EACH PARTY WILL BE SOLELY AND INDIVIDUALLY
                  RESPONSIBLE TO COMPLY WITH ALL LAWS AND REGULATIONS RELATING
                  TO ITS RESPECTIVE BUSINESS OPERATIONS.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>12. LIMITATION OF LIABILITY</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  YOU EXPRESSLY UNDERSTAND AND AGREE THAT UNDER NO CIRCUMSTANCES
                  SHALL NOTABLE, ITS LICENSORS OR CONTENT PROVIDERS BE LIABLE TO
                  ANY USER ON ACCOUNT OF THAT USER'S USE OR MISUSE OR RELIANCE
                  ON THE SERVICES. THIS LIMITATION OF LIABILITY SHALL APPLY TO
                  PREVENT RECOVERY OF DIRECT, INDIRECT, INCIDENTAL,
                  CONSEQUENTIAL, SPECIAL, EXEMPLARY, AND PUNITIVE DAMAGES (EVEN
                  IF NOTABLE, ITS LICENSORS OR CONTENT PROVIDERS HAVE BEEN
                  ADVISED OF THE POSSIBILITY OF SUCH DAMAGES). SUCH LIMITATION
                  OF LIABILITY SHALL APPLY WHETHER THE DAMAGES ARISE FROM USE OR
                  MISUSE OF AND RELIANCE ON THE SERVICES, FROM INABILITY TO USE
                  THE SERVICES, OR FROM THE INTERRUPTION, SUSPENSION, OR
                  TERMINATION OF THE SERVICES (INCLUDING SUCH DAMAGES INCURRED
                  BY THIRD PARTIES).
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  UNDER NO CIRCUMSTANCES SHALL NOTABLE, ITS LICENSORS OR CONTENT
                  PROVIDERS BE HELD LIABLE FOR ANY DELAY OR FAILURE IN
                  PERFORMANCE RESULTING DIRECTLY OR INDIRECTLY FROM ACTS OF
                  NATURE, FORCES, OR CAUSES BEYOND ITS REASONABLE CONTROL,
                  INCLUDING, WITHOUT LIMITATION, INTERNET FAILURES, EQUIPMENT
                  FAILURES, OR ACTS OF GOD.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  IF, NOTWITHSTANDING THESE LIMITATIONS OF LIABILITY, NOTABLE IS
                  DETERMINED BY A COURT OF COMPETENT JURISDICTION TO BE LIABLE
                  TO YOU IN ANY WAY, IN NO EVENT SHALL NOTABLE'S LIABILITY
                  EXCEED THE FEES YOUR HEALTHCARE ORGANIZATION HAS PAID TO
                  NOTABLE DURING THE TWELVE-MONTH PERIOD IMMEDIATELY PRECEDING
                  YOUR CLAIM. YOU AND NOTABLE AGREE THAT THE FOREGOING
                  LIMITATION OF LIABILITY IS AN AGREED ALLOCATION OF RISK
                  BETWEEN YOU AND NOTABLE. YOU ACKNOWLEDGE THAT ABSENT YOUR
                  AGREEMENT TO THIS LIMITATION OF LIABILITY, NOTABLE WOULD NOT
                  PROVIDE THE SERVICES TO YOU.
                </span>
              </p>
              <p className={styles.p7}>
                <span className={styles.s1}>
                  In some jurisdictions, limitations of liability are not
                  permitted. In such jurisdictions, the foregoing limitation may
                  not apply to you.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>13. INDEMNITY</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  You agree to defend, indemnify and hold Notable and its
                  respective directors, officers, employees, stockholders and
                  agents harmless against any losses, expenses, costs or damages
                  (including Notable's reasonable attorneys' fees, expert fees'
                  and other reasonable costs of litigation) in connection with,
                  arising out of, resulting from or caused by (1) your material
                  breach of these Terms, (2) your unauthorized or unlawful use
                  of the Services or the Content, and (3) the unauthorized or
                  unlawful use of the Services by any other person using your
                  Credentials.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>14. COOPERATION WITH GOVERNMENT AUTHORITIES</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Notable will cooperate with local, state, federal,
                  international and/or worldwide government authorities to
                  protect the Services, visitors, customers, Notable, its
                  parents, subsidiaries, affiliates and their respective
                  members, directors, officers, employees, stockholders and
                  agents and operational providers, when Notable determines, in
                  its discretion, that such cooperation is appropriate to
                  prevent or remedy unauthorized use of the Services.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>15. LINKS TO OTHER MATERIALS</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  The Services may include links to third-party sites. The
                  linked sites are not necessarily under the control of Notable
                  and Notable is not responsible for nor does it certify the
                  content of any linked site or any link contained in a
                  non-affiliated linked site. Notable reserves the right to
                  terminate any link or linking program at any time. The
                  selection or omission of links is not intended to endorse any
                  particular companies or products. If you decide to access any
                  of the third party sites linked through the Services, you do
                  so entirely at your own risk. Notable shall have the right to
                  disable or remove any link that violates any rights of Notable
                  or causes interruption or deterioration of the Services.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>16. APPLICABLE LAWS</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Notable makes no representation that the Services or Content
                  are appropriate or available for use in any particular
                  jurisdiction, and access to them from jurisdictions where
                  their content is illegal is prohibited. Those who choose to
                  access the Services from other locations do so on their own
                  initiative and are responsible for compliance with applicable
                  local laws. You may not use or export the Services or any
                  Content in violation of United States export laws or
                  regulations. Any claim relating to the Services or these Terms
                  shall be governed by the internal substantive laws of the
                  State of California.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>17. ENTIRE AGREEMENT</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  These Terms, contain the entire agreement between you and
                  Notable relating to the subject matter hereof, and supersede
                  any other oral or written communications relating thereto.
                  These Terms may not be amended or supplemented by (1) any
                  email message, purchase order, or similar communication
                  originated by you relating to the subject matter hereof, or
                  (2) statements of any of Notable's employees. If we make
                  material changes to these Terms, we will notify you of such
                  changes by posting them on the Notable Platform or by sending
                  you an email or other notification, and we will indicate when
                  such changes will become effective. By continuing to access or
                  use our Service after those revisions become effective, you
                  agree to be bound by the revised Terms.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>18. ASSIGNMENT</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  You may not assign your rights under these Terms without
                  Notable's prior written permission. Any attempt to assign your
                  rights under these Terms without Notable's permission shall be
                  void.
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  You agree that your account is non-transferable and any rights
                  to your username, password, or contents of your account
                  terminate upon your death. Upon receipt of a copy of a death
                  certificate, your account may be terminated and all contents
                  therein permanently deleted.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>19. WAIVER OF BREACH</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Any failure to enforce any term or provision of these Terms
                  shall not be deemed a waiver of that or any other breach of
                  that or any other term or provision. In addition, any failure
                  to enforce any term or provision of these Terms shall not
                  constitute a waiver of a future breach of that or any other
                  term or provision of these Terms.
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>20. NOTICE</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  Notable may deliver notice to you by means of electronic mail
                  to the email address on record in Notable's account
                  information, or by a general notice on the Notable Platform,
                  or by written communication delivered by first class U.S. mail
                  to your address on record in Notable's account information.
                  You may give notice to Notable at any time via electronic mail
                  to hello@notablehealth.com or by letter delivered by first
                  class postage prepaid U.S. mail or overnight courier to the
                  following address:
                </span>
              </p>
              <p className={styles.p8}>
                <span className={styles.s1}>Notable Health</span>
              </p>
              <p className={styles.p8}>
                <span className={styles.s1}>
                  400 S El Camino Real 6<sup>th</sup> Floor
                  <br />
                  San Mateo, CA 94402
                </span>
              </p>
              <p className={styles.p4}>
                <span className={styles.s1}>
                  <b>21. HEADINGS</b>
                </span>
              </p>
              <p className={styles.p7}>
                <span className={styles.s1}>
                  The headings contained in these Terms are for reference
                  purposes only and shall not affect in any way the meaning or
                  interpretation of these Terms.
                </span>
              </p>
              <p className={styles.p6}>
                <span className={styles.s1}>
                  <b>22. INVALIDITY</b>
                </span>
              </p>
              <p className={styles.p5}>
                <span className={styles.s1}>
                  If any provision of these Terms shall be held, be deemed, or
                  shall in fact be, invalid, inoperative or unenforceable as
                  applied to any particular case or circumstance because of the
                  conflicts of any provision with any law, regulation, ordinance
                  or for any other reason, the provision or provisions in
                  question shall not be invalid, inoperative or unenforceable in
                  any other case or circumstance, nor shall any other provision
                  or provisions herein contained thereby be or become invalid,
                  inoperative or unenforceable and such provision shall be
                  reformed so that it would be valid, operative and enforceable
                  to the maximum extent permitted in such circumstances.
                </span>
              </p>
              <p className={styles.p9}>
                <span className={styles.s1}></span>
              </p>
            </div>
          </div>
        </div>
        <div className={styles.SchedulingSeparator} />
        <Footer />
      </div>
    </>
  );
};

export default PatientTermsOfUse;
